const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export const initGA = () => {
  try {
    if (!GA_ID || window.__wzGaInit) return;
    window.__wzGaInit = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
  } catch { /* analytics must never break the UI */ }
};

export const trackPageView = (path) => {
  try {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  } catch { /* ignore */ }
};

export const gaEvent = (name, params = {}) => {
  try {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", name, params);
  } catch { /* ignore */ }
};
